import React from "react";
import { useHistory } from "react-router-dom";

import { useAppContext } from '../../contexts/app';

const HeaderNavAdmin = () => {
  const history = useHistory();
  const { adminAuthToken, logout } = useAppContext();

  return (
    <div className="header">
      <div>
        出展者専用バッジ申請サイト 管理者ページ
      </div>
      {adminAuthToken &&
        <div>
          <div className="btn" onClick={() => {logout('admin'); history.push('/admin/login');}}>
            ログアウト
          </div>
        </div>
      }
    </div>
  );
}

export default HeaderNavAdmin;
